"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCADParsingMessageType = void 0;
var OrCADParsingMessageType;
(function (OrCADParsingMessageType) {
    OrCADParsingMessageType["UnknownProperty"] = "orcad-unknown-property";
    OrCADParsingMessageType["UnknownNode"] = "orcad-unknown-node";
    OrCADParsingMessageType["UnexpectedValue"] = "orcad-unexpected-value";
    OrCADParsingMessageType["ParsingWarning"] = "orcad-parsing-warning";
})(OrCADParsingMessageType || (exports.OrCADParsingMessageType = OrCADParsingMessageType = {}));
//# sourceMappingURL=OrCADParsingResult.js.map